import { FC } from "react";
import './EpiStatusChip.scss';

interface ChipProps {
	label: string;
	color: string;
	filled?: boolean;
}

export const EpiStatusChip: FC<ChipProps> = ({ label, color, filled }) => (
	<span
		className="epi-status-chip"
		style={filled
			? { backgroundColor: color, borderColor: color, color: '#ffffff' }
			: { borderColor: color, color: color }}
	>
		{label}
	</span>
);

interface BadgeProps {
	value: number;
	color: string;
}

export const EpiCountBadge: FC<BadgeProps> = ({ value, color }) => (
	<span className="epi-count-badge" style={{ borderColor: color, color: color }}>
		{value}
	</span>
);
